import React, { FunctionComponent, useEffect, useState, useCallback, useRef } from "react";
import BrandKindSelect from "@Components/common/singleModelSelect/brandKindSelect";
import { fetchNewCarBrands, fetchNewCarKinds, fetchModel } from "@Services/article";
import { host } from "@Services/url";
import { useSetState } from "ahooks-v2";
import { IKindInfo } from "./context";
import throttle from "lodash/throttle";
import cx from "classnames";
import styles from "./right.module.less";

interface IProps {
  dataSource: IKindInfo[];
  compareMyid: string | undefined;
  setCompare: React.Dispatch<React.SetStateAction<string | undefined>>;
}

interface IDataSource {
  index: any[];
  brand: any[];
  kindNum: number;
}

let timeId = 0;

const { imageNew } = host;

const Compare: FunctionComponent<IProps> = ({ dataSource, setCompare, compareMyid }) => {
  const targetRef = useRef<HTMLDivElement>(null);
  const [flag, setFlag] = useState<boolean>(false);
  const [isClose, setClose] = useState<boolean>(false);
  const [isRealClose, setRealClose] = useState<boolean>(false);
  const [isShowClear, setShowClear] = useState<boolean>(false);
  const [newCarKind, setNewCarKind] = useState<any[]>([]);
  const [newCarModel, setNewCarModel] = useState<any[]>([]);
  const [isShowPrew, setPrew] = useState<boolean>(false);
  const [newCarDataSource, setNewCarDataSource] = useState<IDataSource>({
    index: [],
    brand: [],
    kindNum: 0,
  });
  const [params, setParams] = useSetState<any>({
    kindId: undefined,
    brandId: undefined,
    myid: undefined,
  });
  const [left, setLeft] = useState<number>(0);

  const initLeft = throttle(() => {
    const dom = document.querySelector(".carTypBodyDetail");

    if (dom) {
      const { left } = dom.getBoundingClientRect();
      setLeft(left);
    }
  }, 60);

  const scrollTo = useCallback((scrollValue) => {
    let scrollLeft = targetRef.current!.scrollLeft;
    targetRef.current!.scrollTo(scrollLeft + scrollValue, 0);
    console.log(scrollLeft + scrollValue);
  }, []);

  const fetchSelect = async () => {
    const res = await fetchNewCarBrands({ type: "superTest" });

    if (res && res.status === 12000) {
      setNewCarDataSource(res.data);
    }
  };

  const handleScroll = () => {
    if (!flag) return;

    if (!isClose) {
      setClose(true);
    }
    clearTimeout(timeId);
    timeId = window.setTimeout(() => {
      !isRealClose && setClose(false);
    }, 2000);
  };

  const handleNewCarBrandSelect = async (brand: number) => {
    setNewCarKind([]);
    setParams({ brandId: brand });
    const res = await fetchNewCarKinds({ b: brand, type: "superTest" });
    if (res && res.status === 12000) {
      setNewCarKind(res.data.data);
      setShowClear(true);
    }
  };

  const handleNewCarKindSelect = async (data: any) => {
    setNewCarModel([]);
    setParams({ kindId: data.kindId });
    const res = await fetchModel({ k: data.kindId, type: "superTest" });
    console.log(res);
    // @ts-ignore
    if (res) {
      // @ts-ignore
      setNewCarModel(res.data.list);
      setShowClear(true);
    }
  };

  const onSubmit = (data: any) => {
    setParams({ myid: data.myid });
    setCompare(data.myid);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [isClose, isRealClose, flag]);

  useEffect(() => {
    initLeft();
    fetchSelect();
    window.addEventListener("resize", initLeft);

    setTimeout(() => {
      setFlag(true);
    }, 10000);

    return () => {
      window.removeEventListener("resize", initLeft);
    };
  }, []);

  const handleContentScroll = () => {
    setPrew(!!targetRef.current!.scrollLeft);
  };

  useEffect(() => {
    if (targetRef.current) {
      targetRef.current.addEventListener("scroll", handleContentScroll);
      () => targetRef.current && targetRef.current.addEventListener("scroll", handleContentScroll);
    }
  }, []);

  return (
    <div className={styles["compare"]}>
      <div className={styles["compare-bg"]} style={{ left: isClose ? "-887px" : "0" }}></div>
      <div className={styles["compare-content"]} style={{ left: isClose ? "-887px" : "0" }} ref={targetRef}>
        {dataSource &&
          dataSource.map((item, inx) => (
            <div className={styles["item"]} key={inx} title={item.title}>
              <img src={item.thumb} alt='' />
              <p>{item.title}</p>
            </div>
          ))}
        <div className={cx(styles["item"], styles["add-item"])}>
          <img src={`${imageNew}/article/superTest/car.png`} alt='' />
          <button>{!compareMyid ? "+添加車型" : "重新選擇"}</button>
          <div className={styles["pop"]}>
            <BrandKindSelect
              type='supertest'
              field={"newcar"}
              selectLabel={"選擇廠牌車款"}
              dataSource={newCarDataSource}
              kindData={newCarKind}
              modelData={newCarModel}
              onBrandSelect={handleNewCarBrandSelect}
              onKindSelect={handleNewCarKindSelect}
              onClear={() => {
                setParams({
                  kindId: undefined,
                  brandId: undefined,
                });
                setShowClear(false);
              }}
              isShowClear={isShowClear}
              onSubmit={onSubmit}
            />
          </div>
        </div>
      </div>
      <div
        style={{ left: isClose ? left : "unset" }}
        className={cx(styles["title"], {
          [styles["close-title"]]: isClose,
        })}
        onClick={() => {
          setClose(false);
          setRealClose(false);
        }}
      >
        超 測 比 較
      </div>
      <div
        className={styles["close"]}
        onClick={() => {
          setClose(true);
          setRealClose(true);
        }}
      ></div>
      {dataSource?.length > 3 && !isClose && isShowPrew && (
        <div className={styles["prev"]} onClick={() => scrollTo(-785)}></div>
      )}
      {dataSource?.length > 3 && !isClose && <div className={styles["next"]} onClick={() => scrollTo(785)}></div>}
    </div>
  );
};

export default Compare;
